<template>
  <div>
    <parametre-autocomplete
      v-if="column.searchType === constantes.FILTRE_TYPE_AUTOCOMPLETE_PARAMS"
      v-model="search"
      :target="column.target"
      field="libelle"
      selector="id"
      :create="false"
      :clearable="true"
      :placeholder="$t('general.placeolderSearch')"
      @input="$emit('reloadItemsForSearch')"
    />
    <b-select
      v-else-if="column.searchType === constantes.FILTRE_TYPE_SELECT"
      v-model="search"
      :placeholder="$t('general.placeolderSearch')"
      expanded
      @input="$emit('reloadItemsForSearch')"
    >
      <option value="">{{ $t('general.tous') }}</option>
      <option
        v-for="option in column.searchOptions"
        :key="option.value"
        :value="option.value">
        {{ $t(option.label) }}
      </option>
    </b-select>
    <b-input
      v-else-if="column.searchType === constantes.FILTRE_TYPE_INPUT"
      v-model="search"
      :placeholder="$t('general.placeolderSearch')"
      @input="$emit('reloadItemsForSearch')"
			icon="magnify"/>
  </div>
</template>
<script>
import {
  FILTRE_TYPE_INPUT,
  FILTRE_TYPE_SELECT,
  FILTRE_TYPE_AUTOCOMPLETE_PARAMS,
} from '@/configuration/tableConfig';
import ParametreAutocomplete from '@/components/general/parametreAutocomplete.vue';

export default {
  name: 'QdFilterTableRow',
  components: {
    ParametreAutocomplete,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        FILTRE_TYPE_INPUT,
        FILTRE_TYPE_SELECT,
        FILTRE_TYPE_AUTOCOMPLETE_PARAMS,
      },
    };
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
